/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { config, SETTING_KEY } from '../../config/Config';
toast.configure();

const Received = ({ received, setReceived }) => {
  const { t } = useTranslation();

  const getSetting = async () => {
    const resp = await axios.get(config.API_URL.SETTING.GET, {
      params: {
        key: SETTING_KEY.RECEIVED,
      },
      headers: config.headers,
    });
    const { data } = resp;
    const { setting } = data;
    setReceived({
      value: setting.value || 0,
    });
  };

  useEffect(() => {
    getSetting();
  }, []);

  const handlerChange = (e) => {
    const newValue = {
      ...received,
      [e.target.name]: e.target.value,
    };
    setReceived(newValue);
  };

  return (
    <div className="setting">
      <h3>{t('number_of_received')}</h3>
      <div className="row flex items-center gap-x-4">
        <label>{t('number_of_received')}: </label>
        <input type="text" value={received.value} name="value" onChange={handlerChange} />
      </div>
    </div>
  );
};
export default Received;
